import { reactive } from 'vue'

export type ToastType = 'success' | 'error' | 'info'

export interface Toast {
  id: number
  type: ToastType
  message: string
}

// Module-level state so every component shares the same toast stack;
// ToastHost.vue renders it once at the app root.
const toasts = reactive<Toast[]>([])
let nextId = 1

const DEFAULT_TIMEOUT: Record<ToastType, number> = {
  success: 4000,
  info: 5000,
  error: 8000
}

function push(type: ToastType, message: string, timeout?: number): void {
  const id = nextId++
  toasts.push({ id, type, message })
  const ms = timeout ?? DEFAULT_TIMEOUT[type]
  if (ms > 0) {
    setTimeout(() => dismiss(id), ms)
  }
}

function dismiss(id: number): void {
  const index = toasts.findIndex(t => t.id === id)
  if (index !== -1) {
    toasts.splice(index, 1)
  }
}

export function useToast() {
  return {
    toasts,
    dismiss,
    success: (message: string, timeout?: number) => push('success', message, timeout),
    error: (message: string, timeout?: number) => push('error', message, timeout),
    info: (message: string, timeout?: number) => push('info', message, timeout)
  }
}
